import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'rma-renting',
  imports: [TranslocoModule, MatButtonModule],
  templateUrl: './renting.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RentingComponent {}
